import constants from './constants';
const LogHelper = function () {
    this.writeLog = async function (type, message) {
        await Excel.run(async (context) => {
            const sheetName = constants.LogSheetName;
            const workbook = context.workbook;
            const sheets = workbook.worksheets;

            // Check if "Logs" sheet exists
            let logSheet = sheets.getItemOrNullObject(sheetName);
            await context.sync();

            if (logSheet.isNullObject) {
                // If not exists, create it
                logSheet = sheets.add(sheetName);
                logSheet.getRange("A1:C1").values = [[constants.LogSheetColumns.Type, constants.LogSheetColumns.Time, constants.LogSheetColumns.Message]];
            } else {
                // If exists, check headers
                const headerRange = logSheet.getRange("A1:C1");
                headerRange.load("values");
                await context.sync();

                const headers = headerRange.values[0];
                if (headers[0] !== constants.LogSheetColumns.Type || headers[1] !== constants.LogSheetColumns.Time || headers[2] !== constants.LogSheetColumns.Message) {
                    headerRange.values = [[constants.LogSheetColumns.Type, constants.LogSheetColumns.Time, constants.LogSheetColumns.Message]];
                }
            }

            // Find the last row
            // const usedRange = logSheet.getUsedRange();
            // usedRange.load("rowCount");
            // await context.sync();
            // const nextRow = usedRange.rowCount + 1;

            // Insert a new row at row 2
            const range = logSheet.getRange("2:2");
            range.insert(Excel.InsertShiftDirection.down);

            // Insert new log
            const timeNow = new Date().toLocaleString();
            logSheet.getRange(`A2:C2`).values = [[type, timeNow, message]];

            await context.sync();
            console.log(`Log written: [${type}] ${message}`);
        });
    };
    this.LogTypes = {
        Msg: "Message",
        Warn: "Warning",
        Error: "Error",
    };
}

export default LogHelper;
